import { ChangeEvent, FC } from 'react'

import Box from '@mui/material/Box'
import Pagination from '@mui/material/Pagination'

import { useMediaSize } from 'hooks/useMediaSize'

import s from './styles'

interface Props {
  onChange: (event: ChangeEvent<unknown>, value: number) => void
  page: number
  count?: number
}

const TablePagination: FC<Props> = ({ count, page, onChange }) => {
  const { inputSize } = useMediaSize()

  return (
    <Box sx={s.paginationWrapper}>
      {!!count && (
        <Pagination
          page={page + 1}
          onChange={onChange}
          size={inputSize}
          count={count}
          color="primary"
          shape="rounded"
          showFirstButton
          showLastButton
        />
      )}
    </Box>
  )
}

export default TablePagination
